module.exports = __webpack_public_path__ + "static/img/ARAP21P_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAP21P_1.png
// module id = QrtZ
// module chunks = 0